import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]
  static classes = ["selected", "unselected"]

  connect() {
    this.updateStyles()
  }

  toggle() {
    // For radio buttons, update all cards in the same group
    this.updateRadioGroup()
  }

  updateRadioGroup() {
    const name = this.inputTarget.name
    const allRadios = document.querySelectorAll(`input[type="radio"][name="${name}"]`)

    allRadios.forEach(radio => {
      const controller = this.application.getControllerForElementAndIdentifier(
        radio.closest('[data-controller="select-card"]'),
        "select-card"
      )
      if (controller) {
        controller.updateStyles()
      }
    })
  }

  updateStyles() {
    const isSelected = this.inputTarget.checked
    const label = this.element

    if (isSelected) {
      // Remove unselected classes and add selected classes
      this.unselectedClasses.forEach(cls => label.classList.remove(cls))
      this.selectedClasses.forEach(cls => label.classList.add(cls))
    } else {
      // Remove selected classes and add unselected classes
      this.selectedClasses.forEach(cls => label.classList.remove(cls))
      this.unselectedClasses.forEach(cls => label.classList.add(cls))
    }
  }
}
